import * as R from "ramda";
import { NQRecord } from "../../features/history/types";

export const sortChronologically = (records: NQRecord[]) => {
    return R.sort((a, b) => b.date.getTime() - a.date.getTime(), records)
}
